import { commonHelpers } from 'utilities/helpers';

interface props {
    num: number;
    tit: string;
    roundfunction?: any;
}

export const NumberAndTitle = ({
    num,
    tit,
    roundfunction = commonHelpers.roundTenThousandYen,
}: props) => {
    return (
        <section>
            <div className="number-and-title-tit" style={{ marginBottom: 16 }}>
                {tit}
            </div>
            <div>
                <span className="title-12 mr-[8px]">
                    {num ? commonHelpers.formatNumberMoney(roundfunction(num)) : undefined}
                </span>{' '}
                <span className="title-2-unit">万円</span>
            </div>
        </section>
    );
};
